import { all, call } from 'redux-saga/effects'

import { twoFASagas } from './2FA/2FA-sagas'
import { acquiringSagas } from './acquiring/acquiring-sagas'
import { addressesSagas } from './addresses/addresses-sagas'
import { alertSagas } from './alert/alert-sagas'
import { allAssetsSagas } from './allAssets/allAssets-sagas'
import { batchPaymentsSagas } from './batchPayments/batchPayments-sagas'
import { cardsSagas } from './cards/cards-sagas'
import { commonSagas } from './common/common-sagas'
import { currenciesSagas } from './currencies/currencies-sagas'
import { dashboardSagas } from './dashboard/dashboard-sagas'
import { digitalAssetSagas } from './digitalAssets/digitalAssets-sagas'
import { favouritesDashboardSagas } from './favouritesDashboard/favouritesDashboard-sagas'
import { ledgerSagas } from './ledger/ledger-sagas'
import { limitedTokensSaga } from './limitedTokens/limitedTokens-sagas'
import { referralsSagas } from './referrals/referrals-sagas'
import { settingsSagas } from './settings/settings-sagas'
import { signalRSagas } from './signalR/signalR-sagas'
import { toastSagas } from './toast/toast-sagas'
import { tradingDeskSagasV2 } from './tradingDeskV2/tradingDeskV2-sagas'
import { transactionsSagas } from './transactions/transactions-sagas'
import { userSagas } from './user/user-sagas'

export default function* rootSaga() {
    yield all([
        call(userSagas),
        call(ledgerSagas),
        call(transactionsSagas),
        call(toastSagas),
        call(favouritesDashboardSagas),
        call(alertSagas),
        call(settingsSagas),
        call(twoFASagas),
        call(tradingDeskSagasV2),
        call(commonSagas),
        call(digitalAssetSagas),
        call(limitedTokensSaga),
        call(signalRSagas),
        call(dashboardSagas),
        call(allAssetsSagas),
        call(cardsSagas),
        call(acquiringSagas),
        call(addressesSagas),
        call(currenciesSagas),
        call(referralsSagas),
        call(batchPaymentsSagas),
    ])
}
